
export const MIN_PASSWORD_SIZE = 8